// import { AxiosRequestConfig } from "axios";
import { IColumn } from "entities/ApiModel/IColumn";
import { IncludeAgencyConfiguration } from "utils/data/enum";
import { LocalStorageKeys } from "utils/data/enum";
import { Signature } from "entities/UIModel/Signature";
import { SignatureConfigurationNode } from "entities/ApiModel/SignatureConfigurationNode";
import { SignatureImage } from "entities/ApiModel/SignatureImage";
import { StoreActionApi } from "react-sweet-state";

import { axiosSecuredInstance } from "configurations/axiosConfig";
import { createHook } from "react-sweet-state";
import { createStore } from "react-sweet-state";
// import { mapToUiSignatures } from "utils/data/signatureGridhelper";
import { orderBy } from "lodash";
import { SignatureSearchCriteria } from "entities/UIModel";
import { toBase64 } from "utils/shared";

type CheckNameSignature = SignatureImage & { ErrorMessage?: string; };

type State = {
  error: any;
  isLoading: boolean;
  isSaving: boolean;
  signatures: Signature[];
  cachedSignature: Signature | null;
  signatureModified: number;
  requestTimeoutMs?: number;
  gridColumns?: IColumn[];
  loadingProgress: number;
};
type Actions = typeof actions;
type StoreApi = StoreActionApi<State>;

// const setError =
//   (error: string | null) =>
//     ({ setState }: StoreApi) => {
//       setState({ error });
//     };

// const getData =
//   (
//     url: string,
//     action: (param: Array<any>) => ({ setState }: StoreApi) => any,
//     config?: AxiosRequestConfig
//   ) =>
//     async ({ dispatch }: StoreApi) => {
//       try {
//         const { data } = await axiosSecuredInstance.get(url, config);
//         dispatch(action(data));
//         return data;
//       } catch (error: any) {
//         dispatch(setError(error));
//       }
//     };

// export interface SignatureSearchCriteria {
//   agencyId?: string;
//   searchText?: string;
//   isActive?: boolean;
//   // page?: number;
//   requestedPage?: number;
//   // pageSize?: number;
//   listCount?: number;
//   sortColumn?: string;
// }

const setSignatures =
  ( 
    data: Array<SignatureImage>, 
    updateState: boolean = false,
  ) => ({ setState }: StoreApi) => {
      const mappedSignatures: Signature[] = data?.map((signature) => mapToSignature(signature)) || [];
      setState({
        //signatures: data?.map((signature) => mapToSignature(signature)) || [],
        isLoading: false,
        error: null,
        cachedSignature: null,
      });

      if (updateState) {
        setState({signatures: mappedSignatures})
      }

      return mappedSignatures;
    };

const setSignature =
  (signatureImage: SignatureImage) =>
    ({ setState }: StoreApi) => {
      const cachedSignature = mapToSignature(signatureImage);
      setState({
        cachedSignature: cachedSignature,
        isLoading: false,
      });

      return cachedSignature;
    };

const removeFromSignatures =
  (signatureId: number) =>
    ({ getState, setState }: StoreApi) => {
      const signatures = getState().signatures;
      if (signatures !== undefined) {
        setState({
          signatures: signatures.filter(s =>
            s.signatureImageID !== signatureId)
        });
      }
    };

const updateSignatures =
  (signature: Signature) =>
    ({ getState, setState }: StoreApi) => {
      const signatures = getState().signatures;
      if (signatures !== undefined) {
        const id = signature.signatureImageID;
        const updated = signatures.map(s => s.signatureImageID === id ? signature : s);
        setState({
          signatures: orderBy(updated, "signatureImageName")
        });
      }
    };
const setColumns =
  (columns: IColumn[]) =>
    ({ setState }: StoreApi) => {
      const gridColumns = columns || [];
      localStorage.setItem(LocalStorageKeys.COLUMNS_MANAGE_SIGNATURE, JSON.stringify(gridColumns));
      setState({ gridColumns: gridColumns });
      return { gridColumns: gridColumns };
    };


const mapToSignature = (signature: SignatureImage): Signature => ({
  signatureImageID: signature.SignatureImageID,
  signatureImageName: signature.SignatureImageName,
  signatureImageDescription: signature.SignatureImageDescription,
  signatureImageSourceTypeCode: signature.SignatureImageSourceTypeCode,
  signatureImageFontTypeCode: signature.SignatureImageFontTypeCode,
  signatureImageFormatTypeCode: signature.SignatureImageFormatTypeCode,
  signatureImageData: toBase64(signature.SignatureImageData),
  signatureLevelTypeCode: signature.SignatureLevelTypeCode,
  signatureLevelTypeName :signature.SignatureLevelTypeName,
  signatureConfiguration: signature.SignatureConfiguration,
  integrationKey: signature.IntegrationKey,
  isDefaulted: signature.IsDefaulted,
  isDefaultedByOther: signature.IsDefaultedByOther || 0,
  signatureCreatedByUser: signature.SignatureCreatedByUser,
  signatureCreatedDate: signature.SignatureCreatedDate,
  isModify: signature.IsModify ,
  signatureImagePath : signature.SignatureImagePath ,
  signatureImageFileName : signature.SignatureImageFileName,
  rowsPerPage: signature.RowsPerPage || 0,
  totalRows: signature.TotalRows || 0,
  currentPage: signature.CurrentPage || 0,
  totalPages: signature.TotalPages || 0,
});

// export const toBase64 = (data: string): string => {
//   return data?.startsWith("data:image/")
//     ? data
//     : `data:image/jpeg;base64,${data}`;
// };

const mapToSignatureImage = (signature: Signature): SignatureImage => ({
  SignatureImageID: signature.signatureImageID,
  SignatureImageName: signature.signatureImageName,
  SignatureImageDescription: signature.signatureImageDescription,
  SignatureImageSourceTypeCode: signature.signatureImageSourceTypeCode,
  SignatureImageFormatTypeCode: signature.signatureImageFormatTypeCode,
  SignatureImageFontTypeCode: signature.signatureImageFontTypeCode,
  IsOffline: 0,
  EnteredByUserID: "00000000-0000-0000-0000-000000000000",
  SignatureConfiguration: signature.signatureConfiguration,
  SignatureImageData: toBase64(signature.signatureImageData),
  SignatureLevelTypeCode: signature.signatureLevelTypeCode,
  IntegrationKey: signature.integrationKey,
  IsDefaulted: signature.isDefaulted,
  SignatureImagePath : signature.signatureImagePath ,
  SignatureImageFileName : signature.signatureImageFileName,
});

const mapToCheckNameSignature = (signature: CheckNameSignature): Signature => ({
  signatureImageID: signature.SignatureImageID,
  signatureImageName: signature.SignatureImageName,
  signatureImageDescription: signature.SignatureImageDescription,
  signatureImageSourceTypeCode: signature.SignatureImageSourceTypeCode,
  signatureImageFormatTypeCode: signature.SignatureImageFormatTypeCode,
  signatureImageFontTypeCode: signature.SignatureImageFontTypeCode,
  signatureConfiguration: signature.SignatureConfiguration,
  signatureImageData: signature.SignatureImageData,
  signatureLevelTypeCode: signature.SignatureLevelTypeCode,
  integrationKey: signature.IntegrationKey,
  isDefaulted: signature.IsDefaulted,
  isDefaultedByOther: signature.IsDefaultedByOther || 0,
  isModify: signature.IsModify,
  rowsPerPage: signature.RowsPerPage || 0,
  totalRows: signature.TotalRows || 0,
  currentPage: signature.CurrentPage || 0,
  totalPages: signature.TotalPages || 0,
});


const initialState = {
  error: null,
  isLoading: false,
  isSaving: false,
  cachedSignature: null,
  signatureModified: 0,
  loadingProgress: 0,
  signatures: [],
};

const actions = {
  checkName: (payload: any) => async () => {
    const url = "/Signature/v2/checkName";

    if (Object.keys(payload).length === 0) return;

    if (!payload.signatureConfiguration) return;

    try {
      const { data } = await axiosSecuredInstance.post(url, payload);
      return mapToCheckNameSignature(data);
    } catch (error: any) {
      if (error?.response?.status === 400) {
        return mapToCheckNameSignature(error.response.data);
      }

      console.error(error);
    }
  },
  // getSignatures:
  //   (agencyId : string = "") =>
  //     async ({ dispatch, setState }: StoreApi) => {
  //       setState({ isLoading: true });
  //       dispatch(getData(`/Signature/v2/getSignatures?AgencyId=${agencyId}`, setSignatures));
  //     },

  getSignatures:
  (
    agencyId: string = "", 
    criteria?: SignatureSearchCriteria, 
    updateState: boolean = false
  ) => async ({ dispatch, setState, getState }: StoreApi): Promise<Signature[]> => {

    setState({ isLoading: true, loadingProgress: 0 });

    const progressInterval = setInterval(() => {
      const current = getState().loadingProgress ?? 0;

      let next = current;
      if (current < 90) next += 10;
      else if (current < 99) next += 1;

      setState({ loadingProgress: next });
    }, 120);

    try {
      const response = await axiosSecuredInstance.get(
        "/Signature/v2/getSignatures",
        {
          params: {
            ...criteria,                         
            AgencyId: agencyId?.trim() || undefined,
          },
          timeout: getState().requestTimeoutMs,
          timeoutErrorMessage: "TIMEOUT",
        }
      );

      clearInterval(progressInterval);
      setState({ isLoading: false, loadingProgress: 100 });

      return (dispatch(setSignatures(response.data, updateState)));

    } 
    catch (error) {
      clearInterval(progressInterval);
      setState({ isLoading: false, loadingProgress: 0 });
      throw error;
    }
  },
  getSignature:
    (
      signatureImageID: number, 
      integrationKey: string,
      isEditAgency: IncludeAgencyConfiguration = IncludeAgencyConfiguration.No
    ) =>
    async ({ dispatch, setState, getState }: StoreApi) => {
      setState({ isLoading: true, loadingProgress: 0 });

      const progressInterval = setInterval(() => {
        const currentProgress = getState().loadingProgress;
        setState({
          loadingProgress: Math.min(currentProgress + 10, 90),
        });
      }, 100);

      try {
        const encodedSignatureKey = btoa(`${signatureImageID}|${integrationKey}`);
        const { data } = await axiosSecuredInstance.get<SignatureImage>(`/Signature/v2/${encodedSignatureKey}`, {
          params: {
            isEditAgency,
          },
        });

        clearInterval(progressInterval);
        setState({ loadingProgress: 100, isLoading: false });

        const currentSignature = dispatch(setSignature(data));
        return currentSignature;
      } catch (error) {
        clearInterval(progressInterval);
        setState({ isLoading: false, loadingProgress: 0 });
        throw error;
      }
    },

  getSignatureConfiguration: () => async () => {
    const { data } = await axiosSecuredInstance.get<SignatureConfigurationNode>(
      "/Signature/v2/getSignatureConfiguration",
    );
    return data;
  },
  getInitialColumnsDefintion: (hidden: boolean) => () => {
    const key = LocalStorageKeys.COLUMNS_MANAGE_SIGNATURE;
    const existingColumns = localStorage.getItem(key) || "[]";
    return JSON.parse(existingColumns);
  },

  getColumnsDefinition:
    () =>
    async ({ dispatch }: StoreApi) => {
      const { data } = await axiosSecuredInstance.get(
        "/UISettings/grids/columnSettings/signatures"
      );
      return dispatch(setColumns(data));
    },
  saveSignature:
    (signature: Signature) =>
    async ({ dispatch, getState, setState }: StoreApi) => {
      try {
        setState({ isSaving: true });
        const mappedData = mapToSignatureImage(signature);
        const { data, status } = await axiosSecuredInstance.post("/Signature/v2/saveSignature", mappedData);
        if (status === 200) {
          const updatedSignature = mapToSignature(data);
          dispatch(updateSignatures(updatedSignature));
          setState({ signatureModified: Number(getState().signatureModified) + 1 });
          setState({ isSaving: false });
          return { success: true };
        }
        setState({ isSaving: false });
        return { success: false };
      } catch (error) {
        console.error(error);
        setState({ error, isSaving: false });
        return { success: false };
      }
    },
  deleteSignature:
    (signatureId: number) =>
    async ({ dispatch, getState, setState }: StoreApi) => {
      try {
        const response = await axiosSecuredInstance.delete(`/Signature/v2/${signatureId}`);
        if (response.status === 200) {
          dispatch(removeFromSignatures(signatureId));
          setState({ signatureModified: getState().signatureModified + 1 });
          return { success: true };
        }
        return { success: false };
      } catch (error) {
        console.error(error);
        setState({ error });
        return { success: false };
      }
    },
  setColumnDefinition:
    (
      fields: string[],
      propName: keyof Omit<IColumn, "field" | "name">,
      value?: string | number | boolean | undefined,
    ) =>
    async ({ dispatch }: StoreApi) => {
      let data: IColumn[] = [];

      if (propName === "position") {
        data = fields.map((field, index) => ({
          field,
          name: "",
          position: index,
        }));
      } else {
        data = fields.map((field) => ({
          field,
          name: "",
          [propName]: value,
        }));
      }

      try {
        const response = await axiosSecuredInstance.post("/UISettings/grids/columnSettings/signatures", data);
        if (response.data) {
          dispatch(setColumns(response.data));
        }
      } catch (error) {
        console.error(error);
      }
    },
};

const Store = createStore<State, Actions>({
  initialState,
  actions,
  name: "signatureContext",
});

const hook = createHook(Store);
export const useSignatures = () => { return hook(); };
